import { encodeFunctionData, parseUnits } from 'viem';
import { getAlchemyPaymasterAddress } from '../alchemyPaymasterAddresses';
import { baseSepolia } from 'viem/chains';
import { usdc } from 'stackup-worker';
export async function addUSDCEncodedApprovalToCallData(args) {
    const { callData, smartAccountClient, allowance } = args;
    const account = smartAccountClient.account;
    const chain = smartAccountClient.client?.chain;
    if (!chain) {
        throw new Error('smartAccountClient.client.chain is undefined');
    }
    if (!account) {
        throw new Error('smartAccountClient.account is undefined');
    }
    const calls = await account.decodeCalls?.(callData);
    if (!calls) {
        throw new Error('failed to decode call data');
    }
    const paymasterAddress = getAlchemyPaymasterAddress(chain, account.entryPoint.version);
    const _allowance = allowance ?? parseUnits('5', 6); // 5 USDC in 6 decimals
    const usdcAddress = chain.id === baseSepolia.id ? usdc.baseSepolia : usdc.base;
    const ERC20_ABI = [
        {
            name: 'approve',
            type: 'function',
            stateMutability: 'nonpayable',
            inputs: [
                { name: 'spender', type: 'address' },
                { name: 'amount', type: 'uint256' },
            ],
            outputs: [{ name: '', type: 'bool' }],
        },
    ];
    const withApproval = [
        {
            to: usdcAddress,
            value: 0n,
            data: encodeFunctionData({
                abi: ERC20_ABI,
                functionName: 'approve',
                args: [paymasterAddress, _allowance],
            }),
        },
        ...calls,
    ];
    const encodedCalls = await account.encodeCalls(withApproval);
    return encodedCalls;
}
